import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { useTextureStock } from 'src/components/3d/Interface/Customization/Textures/useTextureStock';

const EMPTY_HISTORY: Record<string, Record<string, Float32Array>> = {};

type StockRecapProps = {
  step: string;
  pieces: any[];
  history?: Record<string, Record<string, Float32Array>>;
};

export const StockRecap = ({ step, pieces, history }: StockRecapProps) => {
  const { stockData, assemblyStockData } = useTextureStock(
    pieces[0],
    pieces,
    'activePieces',
    history ?? EMPTY_HISTORY,
  );

  const hasOnePiece = pieces.length === 1;
  const isAssemblyInStock = assemblyStockData && assemblyStockData.length > 0;
  const isPieceInStock = stockData && stockData.length > 0;

  const showIcon = hasOnePiece ? isPieceInStock : isAssemblyInStock;

  if (!showIcon) return null;

  return (
    <div
      className='absolute bottom-0 left-0 z-[120] flex h-full flex-col items-end justify-start p-5 pointer-events-none'
      style={{ width: step === 'QUOTE' ? '55vw' : '65vw' }}
    >
      <div className='flex items-center justify-center bg-gold p-2.5 rounded-full border-none gap-2'>
        {hasOnePiece ? (
          <p className='text-white text-sm font-semibold'>Pièce en stock</p>
        ) : (
          <p className='text-white text-sm font-semibold'>Monument en stock</p>
        )}
        <Inventory2OutlinedIcon
          style={{ color: '#ffffff', fontSize: '20px' }}
        />
      </div>
    </div>
  );
};
